import { useMutation } from '@tanstack/react-query';
import { createNewSelectionList } from './createNewSelectionList';
import * as consts from '../../store/constants';
import { invalidateSelectionLists } from './useSelectionLists';
import { AxiosError } from 'axios';
import { globalErrorResponse } from '../../shared/notification/actions';
import { useNavigate } from 'react-router-dom';

export const useCreateNewSelectionList = (withRedirect: boolean = false) => {
    const navigate = useNavigate();

    return useMutation(createNewSelectionList, {
        onSuccess: selectionListId => {
            invalidateSelectionLists().then();
            if (withRedirect) {
                navigate(`${consts.PATH_SELECTIONLISTS}/${selectionListId}`);
            }
        },
        onError: (error: AxiosError) => {
            globalErrorResponse(error);
        }
    });
};
